const addressFields = [
  'line1',
  'line2',
  'line3',
  'city',
  'state',
  'country',
  'postalCode'
];

export default { addressFields };
